import services from './services'

export const { API_GATEWAY_NAME, Auth, API } = services
